// removed by extract-text-webpack-plugin
module.exports = {"oy_input":"oy_input__tdj5Hnnp","small":"small__3cQ4ySxm","tiny":"tiny__220AyE5Y","name":"name__251tFi7d","input":"input__3QOmsUF-","inputWithSearch":"inputWithSearch__1A9W-pJv","icon_search":"icon_search__2ci8Q72M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OYInput/index.module.less
// module id = 710
// module chunks = 1